import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "w-full flex justify-center" }
const _hoisted_2 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loader = _resolveComponent("Loader")!
  const _component_FirstTimeCourse = _resolveComponent("FirstTimeCourse")!
  const _component_GenericAlert = _resolveComponent("GenericAlert")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Loader, { loader: _ctx.loaderState }, null, 8, ["loader"]),
    _createElementVNode("main", _hoisted_1, [
      (_ctx.isFirstTimeCourse)
        ? (_openBlock(), _createElementBlock("section", _hoisted_2, [
            _createVNode(_component_FirstTimeCourse, {
              onOnCloseFirstTimeCourse: _cache[0] || (_cache[0] = ($event: any) => (_ctx.courseStore.setCourseInitiated()))
            })
          ]))
        : (_openBlock(), _createBlock(_component_GenericAlert, { key: 1 }))
    ])
  ], 64))
}